import request from './../utils/request'


export function index(params) {
  	return request({
  	  url: '/categoryServices',
  	  method: 'get',
        params
  	})
  }

export function inventory(params) {
  return request({
    url: '/category_services/inventory',
    method: 'get',
  })
}


export function show(id) {
    return request({
      url: `/categoryServices/${id}`,
      method: 'get'
    })
  }

  export function store(data) {
    return request({
      url: '/categoryServices',
      method: 'post',
      data
    })
  }

  export function update(data) {
    return request({
      url: `/categoryServices/${data.id}`,
      method: 'put',
      data
    })
  }

  export function destroy(id) {
    return request({
      url: `/categoryServices/${id}`,
      method: 'delete',
    })
  }
